import axios from "axios";
import { getAccessToken, refreshAccessToken, logout } from "./auth";

// Create axios instance
const api = axios.create({
  baseURL: "https://r-requit.onrender.com/api",
  // baseURL: "http://localhost:8000/api",
});

// Attach access token to each request 
api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401 / token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Only handle 401 for non-refresh endpoints
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.endsWith("/auth/token/refresh/")
    ) {
      originalRequest._retry = true;

      try {
        // Try to refresh access token
        const newAccess = await refreshAccessToken();
        originalRequest.headers.Authorization = `Bearer ${newAccess}`;
        return api(originalRequest); // retry original request
      } catch (refreshError) {
        // Refresh failed → logout
        logout();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
